import request from '@/utils/request'
// 文件上传token
export function getUploadToken(parameter) {
  return request({
    url: '/api/ros-website-service/backend/upload/getToken',
    method: 'get',
    params: parameter
  })
}
//登录接口
export function loginApi(data) {
    return request({
      url:'/api/ros-user-service/api/user/login',
      method: 'post',
      data
    })
  }
//注册接口
export function register(data) {
    return request({
      url:'/api/ros-user-service/api/user/register',
      method: 'post',
      data
    })
  }
//获取手机验证码
export function getcode(data) {
    return request({
      url:`/api/ros-user-service/api/sms/send`,  
      method: 'post',
      data
    })
  }
//重置密码
export function resetPassword(data) {
    return request({
      url:`/api/ros-user-service/api/user/resetPassword`,
      method: 'post',
      data
    })
  }
//网站退出登录
export function userLogout(data) {
  return request({
    url:'/api/ros-user-service/api/user/logout',
    method:'post',
    data
  })
}

// 获取国家接口
export function getCountryList() {
  return request({
    url:'/api/ros-website-service/backend/language/queryAllCountry',
    method:'get'
  })
}